import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AdminUsers({ user }) {
  const [admins, setAdmins] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => { loadAdmins(); }, []);

  const loadAdmins = async () => {
    try { const res = await axios.get('/api/auth/admins'); setAdmins(res.data); }
    catch (err) { console.log(err); }
  };

  const createAdmin = async () => {
    if (!newEmail || !newEmail.includes('@')) { setMessage('Gültige E-Mail erforderlich'); return; }
    try {
      const res = await axios.post('/api/auth/create-admin', { email: newEmail });
      setNewEmail('');
      loadAdmins();
      if (res.data.link) {
        setMessage(`Admin erstellt! Link: ${res.data.link}`);
        try { await navigator.clipboard.writeText(res.data.link); setMessage(prev => prev + ' (kopiert!)'); } catch (e) {}
      } else {
        setMessage('Admin erstellt!');
      }
      setTimeout(() => setMessage(''), 15000);
    } catch (err) { setMessage('Fehler: ' + (err.response?.data?.error || err.message)); }
  };

  const deleteAdmin = async (adminId) => {
    if (!window.confirm('⚠️ Admin wirklich löschen?')) return;
    try {
      await axios.delete(`/api/auth/admins/${adminId}`);
      loadAdmins();
      setMessage('Admin gelöscht'); setTimeout(() => setMessage(''), 3000);
    } catch (err) { setMessage('Fehler: ' + (err.response?.data?.error || err.message)); }
  };

  const resetAdminPassword = async (adminId, email) => {
    if (!window.confirm(`Passwort für ${email} zurücksetzen?`)) return;
    try {
      const res = await axios.post(`/api/auth/reset-admin-password/${adminId}`);
      if (res.data.link) {
        setMessage(`🔑 Passwort-Link für ${email}: ${res.data.link}`);
        try { await navigator.clipboard.writeText(res.data.link); setMessage(prev => prev + ' (kopiert!)'); } catch (e) {}
      } else {
        setMessage('Passwort zurückgesetzt');
      }
      setTimeout(() => setMessage(''), 15000);
    } catch (err) { setMessage('Fehler: ' + (err.response?.data?.error || err.message)); }
  };

  return (
    <div style={styles.container}>
      <div style={styles.pageHeader}>
        <h2>Admins verwalten</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button style={styles.backBtn} onClick={() => window.location.href = '/'}>← Zurück</button>
          <img src="/logo.jpg" alt="EliteHomes" style={styles.logoSmall} />
        </div>
      </div>

      {message && <div style={styles.message}>{message}</div>}

      <div style={styles.section}>
        <h3>Neuen Admin einladen</h3>
        <p style={styles.hint}>Der eingeladene Admin erhält einen Link um sein eigenes Passwort zu setzen.</p>
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          <input style={{...styles.input, flex: 1, marginBottom: 0}} type="email" placeholder="E-Mail des neuen Admins"
            value={newEmail} onChange={e => setNewEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && createAdmin()} />
          <button style={styles.button} onClick={createAdmin}>Einladen</button>
        </div>
      </div>

      <div style={styles.section}>
        <h3>Aktive Admins</h3>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>E-Mail</th>
              <th style={styles.th}>Rolle</th>
              <th style={styles.th}>Erstellt am</th>
              <th style={styles.th}>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {admins.map(a => (
              <tr key={a.id}>
                <td style={styles.td}>{a.email}</td>
                <td style={styles.td}>{a.is_superadmin ? '👑 Superadmin' : 'Admin'}</td>
                <td style={styles.td}>{new Date(a.created_at).toLocaleDateString('de-CH')}</td>
                <td style={styles.td}>
                  {!a.is_superadmin && a.id !== user.id && (
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <IconBtn
                        icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>}
                        tooltip="Passwort zurücksetzen"
                        onClick={() => resetAdminPassword(a.id, a.email)} />
                      <IconBtn
                        icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>}
                        tooltip="Admin löschen"
                        onClick={() => deleteAdmin(a.id)} />
                    </div>
                  )}
                  {a.is_superadmin && <span style={{ fontSize: '12px', color: '#888' }}>—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function IconBtn({ icon, tooltip, onClick }) {
  const [hover, setHover] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', padding: '3px' }}
        onClick={onClick} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        {icon}
      </span>
      {hover && (
        <div style={{ position: 'absolute', bottom: '30px', left: '50%', transform: 'translateX(-50%)', whiteSpace: 'nowrap', padding: '5px 10px', backgroundColor: '#333', color: '#fff', borderRadius: '4px', fontSize: '11px', zIndex: 100, pointerEvents: 'none' }}>
          {tooltip}
          <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '5px solid #333' }} />
        </div>
      )}
    </span>
  );
}

const styles = {
  container: { maxWidth: '800px', margin: '0 auto', padding: '20px', minHeight: '100vh' },
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  logoSmall: { width: '120px', height: 'auto' },
  section: { backgroundColor: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px' },
  button: { padding: '10px 20px', backgroundColor: 'rgb(50,180,170)', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  backBtn: { padding: '8px 16px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', marginBottom: '8px' },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: '12px' },
  th: { textAlign: 'left', padding: '10px', borderBottom: '2px solid #ddd', backgroundColor: '#f8f9fa', fontSize: '13px' },
  td: { padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px' },
  message: { padding: '10px', backgroundColor: '#d4edda', borderRadius: '4px', marginBottom: '16px', color: '#155724', wordBreak: 'break-all' },
  hint: { fontSize: '12px', color: '#888', marginTop: '4px' },
};

export default AdminUsers;